import milestoneService from "../../services/milestoneService/service";
import MilestoneModel from "../../models/milestoneModel/model";
export default {
    async fetchMilestone(search, page, limit, company) {
        try {
            const sanitizedSearch = search && search.trim() !== '' ? search : null;
            const { data, headers } = await milestoneService.getMilestones(sanitizedSearch, page, limit, company);
            return {
                data: data.map(milestone => new MilestoneModel(milestone)),
                total: parseInt(headers['x-total-count'], 10), // Header untuk total data
            };
        } catch (error) {
            console.error('Error fetching milestones:', error);
            throw error;
        }
    },
    async totalAllMilestone(search, company_id) {
        try {
            const sanitizedSearch = search && search.trim() !== '' ? search : null;
            return await milestoneService.totalAllMilestones(sanitizedSearch, company_id);
        } catch(error) {
            console.error('Error fetching total milestones:', error);
            throw error;
        }
    },
    async deleteMilestone(id) {
        try {
            return await milestoneService.deleteMilestone(id);
        } catch (error) {
            console.error('Error deleting milestone:', error);
            throw error;
        }
    },
    async addMilestone(milestone) {
        try {
            return await milestoneService.addMilestone(milestone);
        } catch (error) {
            console.error('Error adding milestone:', error);
            throw error;
        }
    },
    async updateMilestone(milestone) {
        try {
            return await milestoneService.updateMilestone(milestone);
        } catch (error) {
            console.error('Error updating milestone:', error);
            throw error;
        }
    }
};